exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-063e1faa] .vs__selected {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  color: white;\n  background-color: #41b883;\n}\n", ""]);

// exports
